import BaseInputValidator from "./BaseInputValidator";

export default class MinMaxNumberValidator implements BaseInputValidator {
    constructor(min: number | null, max: number | null) {
        this.validateInput(min, max);
        this.validationParameters = [min, max]
    }

    validateInput = (min: number | null, max: number | null) => {
        if (min === null && max === null) {
            throw Error("Define at least one parameter min or max")
        }
        if (min !== null && max !== null && min > max) {
            throw Error("Min number cannot be higher than max")
        }
    }

    validate(value: any): boolean {
        let valid = true;
        if (this.validationParameters[0] !== null) {
            valid &&= value >= this.validationParameters[0];
        }
        if (this.validationParameters[1] !== null) {
            valid &&= value <= this.validationParameters[1];
        }
        return valid;
    }

    getErrorMessage(): string {
        let message = 'Value should be ';
        if (this.validationParameters[0] !== null) {
            message += `higher or equal than ${this.validationParameters[0]}`;
        }
        if (this.hasBothValidation()) {
            message += ` and `;
        }
        if (this.validationParameters[1] !== null) {
            message += `lower or equal than ${this.validationParameters[1]}`;
        }
        return message;
    }

    hasBothValidation = (): boolean => this.validationParameters[0] !== null && this.validationParameters[1] !== null;
    validationParameters: [number | null, number | null];
}